var map = {
	"./border.png": "3cec",
	"./eng/北理工.png": "6666",
	"./eng/戴尔.png": "bc5b",
	"./eng/清华.png": "11c2",
	"./北理工.png": "924a",
	"./戴尔.png": "14cb",
	"./清华.png": "58ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "556b";